import { internalApi } from '../../../../internal-api';
import { WidgetSource } from '../../types';
import { orderAssistLogger } from '../../logger';
import {
  ReferralRequestResponse,
  ReferralRequestStatus,
  RequestReferralInput,
} from '../../components/referral-request/types';

export const fetchIsReferralRequestRequired = async (
  token: string | undefined,
  source: WidgetSource | undefined,
): Promise<boolean> => {
  if (!token || !source) {
    orderAssistLogger.warning(
      'isReferralRequired skipping api call - missing parameter - return value is false',
      {
        token,
        source,
      },
    );
    return false;
  }

  const isRequired = await internalApi.orderAssistBff.getMatchedEligibilityPlan(token, source);
  return !!isRequired;
};

export const submitReferralRequest = async (
  input: RequestReferralInput,
  source: WidgetSource | undefined,
): Promise<ReferralRequestResponse> => {
  if (!source) {
    orderAssistLogger.warning('submitReferralRequest skipping api call - source is missing', {
      input,
      source,
    });
    return { status: ReferralRequestStatus.ERROR };
  }

  return internalApi.orderAssistBff.requestReferral(input, source);
};
